import { render, staticRenderFns } from "./Bancontant.vue?vue&type=template&id=1ab3147b&scoped=true"
import script from "./Bancontant.vue?vue&type=script&lang=js"
export * from "./Bancontant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab3147b",
  null
  
)

export default component.exports